import React, {useState} from 'react';
import UserType from './UserType';
import IsListed from './IsListed';
import FAQs from './FAQs';
import Form from '../Form/Form';
import SuccessMsg from './Success';
import './Steps.less';

/* eslint-disable complexity */
const Steps = ({
    globalContent,
    userType,
    listed,
    hasListing,
    form,
    ...rest
}) => {
    const [formStep, setFormStep] = useState(1);

    const handleBackClick = () => {
        if (formStep === 4) {
            setFormStep(2);
        } else {
            setFormStep(formStep - 1);
        }
    };

    const handleUserType = (e) => {
        localStorage.setItem('userType', e.target.id);
        setFormStep(2);
    };

    const handleIsListed = (e) => {
        localStorage.setItem('isListed', e.target.id);

        if (e.target.id === 'Yes') {
            setFormStep(3);
        } else {
            setFormStep(4);
        }
    };

    const handleFormSubmitted = () => {
        setFormStep(5);
    };

    switch (formStep) {
        case 1:
            return <UserType onClick={handleUserType} {...userType} />;

        case 2:
            return (
                <IsListed
                    onBackClick={handleBackClick}
                    onListedClick={handleIsListed}
                    userType={localStorage.getItem('userType')}
                    backText={globalContent.backText}
                    {...listed}
                />
            );

        case 3:
            return (
                <FAQs
                    onBackClick={handleBackClick}
                    isListed={localStorage.getItem('isListed')}
                    btnText={form.success.btnHelp}
                    {...hasListing}
                    {...globalContent}
                />
            );

        case 4:
            return (
                <Form
                    onBackClick={handleBackClick}
                    onFormSubmitted={handleFormSubmitted}
                    userType={localStorage.getItem('userType')}
                    backText={globalContent.backText}
                    {...rest}
                    {...form}
                />
            );

        case 5:
            return (
                <SuccessMsg
                    helpLink={globalContent.helpLink}
                    {...form.success}
                />
            );

        default:
            return <UserType />;
    }
};

export default Steps;
